/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
require('babel-polyfill');
require('./libs/clamp');
require('./bootstrap');

Vue.component('alert', require('vue-strap').alert);



// WEBPACK FOOTER //
// ./resources/assets/js/backend/backend.js